import React from 'react';
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {OfficeForm} from "../../../../components/admin/office/OfficeForm";

export const Add = () => {
  return (
    <>
      <BoxTitle title="Ajouter un bureau"/>
      <OfficeForm />
    </>
  );
}
